export default __webpack_public_path__ + "static/media/home_8.31d7ac49.svg";